class FixedBackgroundPosition {
    constructor(selector) {
        this.elements = document.querySelectorAll(selector);
        this.init();
    }

    init() {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.style.setProperty("--after-visibility", "visible");
                } else {
                    entry.target.style.setProperty("--after-visibility", "hidden");
                }
            });
        });

        this.elements.forEach((element) => {
            element.style.setProperty("--after-visibility", "hidden");
            observer.observe(element);
        });
    }
}

export default FixedBackgroundPosition;
